const normalize = (value) =>
  String(value || "")
    .normalize("NFKD")
    .toLocaleLowerCase()
    .replace(/[^\p{L}\p{N}+#.-]+/gu, " ")
    .trim();

const projectTags = (project) =>
  project.tagsSearchable ?? project.tags_searchable ?? "";

export const projectMatchesFilter = (project, filterId) => {
  if (filterId === "all") return true;
  const filter = normalize(filterId);
  const tokens = normalize(projectTags(project)).split(/\s+/).filter(Boolean);
  return tokens.includes(filter);
};

export const filtersWithProjects = (filters = [], projects = []) =>
  filters.filter((filter) =>
    projects.some((project) => projectMatchesFilter(project, filter.id))
  );

export const projectMatchesSearch = (project, query) => {
  const search = normalize(query);
  if (!search) return true;
  const haystack = normalize(
    `${project.title || ""} ${project.description || ""} ${projectTags(project)}`
  );
  return haystack.includes(search);
};
